<script setup lang="ts">
import { FlexComponent, TypographyComponent } from '../../'

defineProps<{ label: string }>()
</script>

<template>
  <FlexComponent align="center" :gap="8" class="segment-preview-group-heading">
    <TypographyComponent variant="label-large" color="var(--secondary-48)">
      {{ label }}
    </TypographyComponent>
    <span class="segment-preview-group-heading__line" />
  </FlexComponent>
</template>

<style scoped lang="scss">
.segment-preview-group-heading__line {
  flex: 1;
  height: 1px;
  background: var(--button-hover);
}
</style>
